import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { MAX_SHARE_NOTE_NAME_LENGTH } from 'utils/constants';
import styleGuideIcon from 'assets/images/notes/style-guide-empty.jpeg';
import './styles.scss';

const StyleGuideItem = ({
  id,
  title,
  imageUrls,
  shared,
  addToShare,
  removeShare,
}) => {
  const imageUrl = imageUrls ? imageUrls['230w']?.url ?? null :  null;
  const isShared = shared?.findIndex(item => item?.id === id) > -1;

  return (
    <div
      className={clsx('note-item style-guide-item', !imageUrl && 'no-image', isShared && 'selected')}
      onClick={() => {
        if (isShared) {
          removeShare(id);
        } else {
          addToShare(id);
        }
      }}
    >
      <div className="style-guide-item__avatar">
        {imageUrl ? (
          <div
            style={{
              backgroundImage: `url('${imageUrl}')`,
            }}
            className="style-guide-item__image"
          />
        ) : (
          <div className="style-guide-placeholder">
            <img
              src={styleGuideIcon}
              alt={title}
            />
          </div>
        )}
        <div className="style-guide-item__name">
          <div
            className="style-guide-item__name-text"
            title={title}
          >
            {title.length <= MAX_SHARE_NOTE_NAME_LENGTH
            ? title
            : `${title.slice(0, MAX_SHARE_NOTE_NAME_LENGTH)}...`}
          </div>
        </div>
      </div>
    </div>
  );
};

const StyleGuideForm = ({
  items,
  onCopyLink,
  onPrev,
  onNext,
  isLast,
  ...restProps
}) => {
  return (
    <>
      <section>
        <p className="studio-share-modal__intro style-guide-share-modal__intro intro-text">
          Select the items you’d like to share below, and we’ll bundle them up for you to share via link or email.
          Recipients will always see the most current version of each item shared.
          Learn more about your sharing options{' '}
          <a
            href="https://help.aisleplanner.com/en/articles/2083600-sharing-style-guides-color-palettes
          -notes-with-vendors-outside-of-aisle-planner"
            target="_blank"
            rel="noreferrer"
          >
            here
          </a>
          .
        </p>
        <div className={clsx('notes-list--grid', 'style-guide-list')}>
          {items.length === 0 ? (
            <div className="empty-share-step">
              <p className="empty-share-step__text">
                It looks like you don’t have any style guides to share just yet.
                Continue below to select other items to share.
              </p>
            </div>
          ) : (
            <>
              {items.map(item => {
                const { images } = item || {};
                const heroImage = images?.length > 0 ?
                  images.find(img => img.isHeroImage) : null;
                const heroImageUrls = heroImage ? heroImage.imageUrls : null;
                return (
                  <StyleGuideItem
                    key={item.id}
                    id={item.id}
                    title={item.name}
                    imageUrls={heroImageUrls}
                    {...restProps}
                  />
                );
              })}
            </>
          )}
        </div>
      </section>
      <section className="share-form__buttons">
        {isLast ? (
          <button
            type="button"
            className="button"
            onClick={onCopyLink}
          >
            Create Link
          </button>
        ) : (
          <button
            type="button"
            className="button"
            onClick={onPrev}
          >
            Back
          </button>
        )}
        <button
          type="button"
          className="button"
          onClick={onNext}
        >
          Next
        </button>
      </section>
    </>
  );
};

StyleGuideForm.propTypes = {
  items: PropTypes.array,
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  shared: PropTypes.array,
  addToShare: PropTypes.func,
  removeShare: PropTypes.func,
};

StyleGuideForm.defaultProps = {};

export default StyleGuideForm;
